import Vue from "vue"
import Vuex from "vuex"
import axios from "axios"
import {router} from "./router";

Vue.use(Vuex);

var Url = "https://api.mudu.pro/"; // TODO : CANLIDA
//var Url = "http://api.ai/";

const store = new Vuex.Store({
  state: {
    token: "",
    Kullanici_id: "",
    KullaniciAdi: "",
    Hesap: "",
    locale: "tr",
    Sayfa: "",
    Bina: "",
    VT: 'v10' // TODO :  v10 CANLIDA  app
  },
  mutations: {
    setToken(state, data) {
      state.token = data.token;
      state.Kullanici_id = data.id;
      state.KullaniciAdi = data.isim;
    },
    clearToken(state) {
      state.token = "";
      state.Kullanici_id = "";
      state.KullaniciAdi = "";
    },
    SayfaBilgi(state, value) {
      this.state.Sayfa = value;
    },
    Hesap(state, value) {
      state.Hesap = value;
    },
    Bina(state, value) {
      state.Hesap = value;
    },
    Yetki(state, value) {
      state.Hesap = value;
    }
  },
  actions: {
    initAuth({commit, dispatch}) {
      let token = JSON.parse(localStorage.getItem("_ai"))
      if (token) {
        commit("setToken", token);
        commit("Hesap", JSON.parse(localStorage.getItem("_aiHesap")));
      } else {
        if (location.pathname[1] + location.pathname[2] + location.pathname[3] + location.pathname[4] + location.pathname[5] != 'giris') {
          router.push("/giris");
          return false
        }
      }
    },
    Login({commit, dispatch, state}, data) {
      let BaseUrl = Url + data.path;
      $("body").addClass('yukleniyor');
      return axios.post(
        BaseUrl,
        {...data},
        {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'ai-dil': localStorage.getItem('_aiLocale'),
            'ai-vt': state.VT,
            'Cache-Control': 'no-cache',
            'Authorization': 'Bearer ' + state.token,

          }
        }
      ).then(response => {
        if (response.data.Durum == 'OK' && (data.path == 'giris/giris' || data.path == 'giris/hesap' || data.path == 'giris/onay')) {
          //console.log(response);
          if (response.data.Data.Kullanici.Onay === 1) {

            localStorage.removeItem("_ai_G");
            localStorage.removeItem("_aiOturum_G");

            localStorage.setItem("_ai", JSON.stringify(response.data.Data.Kullanici));
            localStorage.setItem("_aiOturum", response.data.Data.Kullanici.id);
            if (response.data.Data.Aidatim) localStorage.setItem("_airoot", true);

            if (response.data.Data.Hesap) {
              localStorage.removeItem("_aiHesap");
              localStorage.setItem("_aiHesap", JSON.stringify(response.data.Data.Hesap));
            }
            commit("setToken", response.data.Data.Kullanici);
          } else {
            localStorage.setItem("_ai_G", JSON.stringify(response.data.Data.Kullanici));
            localStorage.setItem("_aiOturum_G", response.data.Data.Kullanici.id);
            router.push("/giris/onay");
          }
        }
        $("body").removeClass('yukleniyor');
        return response.data;
      })
    },
    Post({commit, dispatch, state}, data) {
      let BaseUrl = null;

      if (!data.Url)
        BaseUrl = Url + data.path;
      else
        BaseUrl = data.Url + data.path;

      $("body").addClass('yukleniyor');
      return axios.post(
        BaseUrl,
        {...data},
        {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'ai-dil': localStorage.getItem('_aiLocale'),
            'ai-vt': state.VT,
            'ai-hesap': state.Hesap.id ? state.Hesap.id : '',
            'Cache-Control': 'no-cache',
            'Authorization': 'Bearer ' + state.token,
          }
        }
      ).then(response => {
        $("body").removeClass('yukleniyor');
        return response.data;
      })
    },
    Put({commit, dispatch, state}, data) {
      let BaseUrl = null;

      if (!data.Url)
        BaseUrl = Url + data.path;
      else
        BaseUrl = data.Url + data.path;

      $("body").addClass('yukleniyor');
      return axios.put(
        BaseUrl,
        {...data},
        {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'ai-dil': localStorage.getItem('_aiLocale'),
            'ai-vt': state.VT,
            'ai-hesap': state.Hesap.id,
            'Cache-Control': 'no-cache',
            'Authorization': 'Bearer ' + state.token,

          }
        }
      ).then(response => {
        $("body").removeClass('yukleniyor');
        return response.data;
      })
    },
    Get({commit, dispatch, state}, data) {
      let BaseUrl = null;

      if (!data.Url)
        BaseUrl = Url + data.path;
      else
        BaseUrl = data.Url + data.path;


      if (data.loading != false) data.loading = true;
      if (data.loading) $("body").addClass('yukleniyor');
      return axios.get(
        BaseUrl,
        {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'ai-dil': localStorage.getItem('_aiLocale'),
            'ai-vt': state.VT,
            'ai-hesap': state.Hesap.id,
            'Cache-Control': 'no-cache',
            'Authorization': 'Bearer ' + state.token
          }
        }
      ).then(
        response => {
          if (data.loading) $("body").removeClass('yukleniyor');
          if (response.data.Status === 401) {
            this.dispatch("logout");
          }
          return response.data;
        },
        error => {
          $("body").removeClass('yukleniyor');
          //$("body").addClass('internetyok');
        });
    },
    Delete({commit, dispatch, state}, data) {
      let BaseUrl = null;

      if (!data.Url)
        BaseUrl = Url + data.path;
      else
        BaseUrl = data.Url + data.path;

      $("body").addClass('yukleniyor');
      return axios.delete(
        BaseUrl,
        {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'ai-dil': localStorage.getItem('_aiLocale'),
            'ai-vt': state.VT,
            'ai-hesap': state.Hesap.id,
            'Cache-Control': 'no-cache',
            'Authorization': 'Bearer ' + state.token,

          }
        }
      ).then(response => {
        $("body").removeClass('yukleniyor');
        return response.data;
      });
    },
    logout({commit}) {

      commit("clearToken");
      localStorage.clear();
      location.reload();

    },
    dataver({state}, params) {
      return axios({
        method: params.method,
        url: Url + state.Kullanici_id + params.url,
        data: params.data,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'Authorization': 'Bearer ' + state.token,
          'ai-dil': localStorage.getItem('_aiLocale'),
          'ai-vt': state.VT
        }
      }).then(response => {
        return response.data;
      });
    },
    Kilavuz({commit, dispatch, state}, data) {
      this.dispatch("Get", {path: 'kilavuz/' + data})
        .then(response => {
          if (response.Durum === 'OK') {
            return response;
          }
        });
    },
    setLocale(locale) {
      localStorage.setItem('_aiLocale', locale);
    }
  },
  getters: {
    isOturum(state) {
      let isOturum = localStorage.getItem('_ai');
      if (!isOturum) isOturum = state.Kullanici_id;
      return isOturum !== ""
    },
    kBilgi() {
      return JSON.parse(localStorage.getItem('_ai'));
    },
    KullaniciBilgi(state) {
      return state;
    },
    Paket(state) {
      let Hesap = JSON.parse(localStorage.getItem('_aiHesap'));
      if (Hesap) return Hesap.Paket
    },
    HizmetBilgi() {
      return JSON.parse(localStorage.getItem('_aiHizmet'));
    },
    HesapId(state) {
      let Hesap = JSON.parse(localStorage.getItem('_aiHesap'));
      if (Hesap) return Hesap.id
    },
    BinaBilgi(state) {
      let BinaBilgi = JSON.parse(localStorage.getItem('_aiBina'));
      if (BinaBilgi) return BinaBilgi;
    },
    Yetki(state) {
      let Yetki = JSON.parse(localStorage.getItem('_aiHesap'))['Yetki'];
      if (Yetki) return Yetki;
    },
    SubDomain(state) {
      return state.VT;
    },
    Admin(state) {
      let Yetki = JSON.parse(localStorage.getItem('_aiHesap'))['Yetkili'];
      if (Yetki) return Yetki;
    },
    Veznedar(state) {
      return JSON.parse(localStorage.getItem('_aiHesap'))['Veznedar'];
    },
    Uruns() {
      return JSON.parse(localStorage.getItem('_aiHizmet'));
    },
    Config(state) {
      let config = {
        headers: {
          'Cache-Control': 'no-cache',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + state.token,
        }
      };
      return config
    }
  },
});

export default store



// WEBPACK FOOTER //
// ./src/store.js